import React, { createContext, useContext, useState } from 'react';

interface TourContextType {
  isTourRunning: boolean;
  currentStep: number;
  setIsTourRunning: (value: boolean) => void;
  setCurrentStep: (value: number) => void;
}

const TourContext = createContext<TourContextType | undefined>(undefined);

export const TourProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isTourRunning, setIsTourRunning] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  return (
    <TourContext.Provider value={{ isTourRunning, currentStep, setIsTourRunning, setCurrentStep }}>
      {children}
    </TourContext.Provider>
  );
};

export const useTour = () => {
  const context = useContext(TourContext);
  if (!context) {
    throw new Error('useTour must be used within a TourProvider');
  }
  return context;
};
